import { useState, useEffect } from 'react';
import { useMutation } from '@apollo/react-hooks';
import SELECT_SHOW_MUTATION from './selectShow.mutation.graphql.js';
import tracking from '@g4/g4-analytics';
import moment from '@g4/moment-utc';
import useStadiumGame from '../../hooks/useStadiumGame';

const useLazySelectStadiumShows = () => {
  const [stadiumShowsToSelect, selectStadiumShows] = useState(null);
  const [selectStadiumShowsSuccess, setSelectStadiumShowsSuccess] = useState(
    false
  );
  const [
    selectStadiumShowsInProgress,
    setSelectStadiumShowsInProgress,
  ] = useState(false);
  const [selectStadiumShowsError, setSelectStadiumShowsError] = useState(null);
  const [stadiumGame] = useStadiumGame();

  const [selectShow] = useMutation(SELECT_SHOW_MUTATION);

  const trackStadiumSeatError = () => {
    tracking.trackEvent(
      'Client Side Error',
      'Booking Path',
      'Stadium seats unavailable',
      null
    );
  };

  useEffect(() => {
    if (stadiumShowsToSelect && !selectStadiumShowsInProgress) {
      // synchronously execute queries
      const { travelers } = stadiumShowsToSelect;
      const { seatIds } = stadiumGame;
      const stadiumSeats = Array.isArray(seatIds) ? seatIds : [];
      let travelersLength = travelers?.length;
      if (stadiumSeats.length !== travelersLength) {
        trackStadiumSeatError();

        return setSelectStadiumShowsError(
          'SelectStadiumShowError_UNKNOWN_ERROR'
        );
      }
      setSelectStadiumShowsInProgress(true);

      const stadiumGameDate = moment(stadiumGame?.date).format('YYYY-MM-DD');
      let stadiumSeatsArray = [];

      stadiumSeats.forEach((seat, index) => {
        stadiumSeatsArray.push({
          categoryId: seat,
          quantity: 1,
          usedByTravelers: [parseInt(travelers[index].id)],
        });
      });

      const selectGameSeats = (stadiumGameDate, stadiumSeatsArray) => {
        return selectShow({
          variables: {
            showDate: stadiumGameDate,
            selectShowDetails: stadiumSeatsArray,
          },
        });
      };

      selectGameSeats(stadiumGameDate, stadiumSeatsArray)
        .then(data => {
          if (data?.data?.selectShow?.order?.status === 'OPEN') {
            setSelectStadiumShowsSuccess(true);
          } else {
            trackStadiumSeatError();
            setSelectStadiumShowsError('SelectStadiumShowError_UNKNOWN_ERROR');
          }
        })
        .catch(() => {
          trackStadiumSeatError();
          setSelectStadiumShowsError('SelectStadiumShowError_UNKNOWN_ERROR');
        });
    }
  }, [
    stadiumShowsToSelect,
    selectShow,
    stadiumGame,
    selectStadiumShowsInProgress,
  ]);

  return {
    selectStadiumShows,
    selectStadiumShowsSuccess,
    selectStadiumShowsError,
  };
};

export default useLazySelectStadiumShows;
